import { ChannelCodeType } from "@global-enum/ChannelCodeType";

export class TokenRequestModel {
  Email: string;
  Password: string;
  ChannelCode = ChannelCodeType.UI
  grant_type = 'refresh_token';
  FirmId: number;
  CaptchaKey: string;
  CaptchaText: string;
  Code: string;
}

export class TokenResponseModel {
  Token: string;
  token_type: string;
  expires_in: string;
}

export class TokenModel {
  ServiceUrl: string;
  Email: string;
  Password: string;
  FirmId: number;
}
